import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import {
  HeaderContainer,
  OrderIssuesContainer,
  OrderIssuesDetails,
  OrderIssuesHeading,
  OrderIssuesText,
  StyledButton,
} from './styled';

export const NeedHelp = ({ children }: { children: React.ReactNode }) => {
  return (
    <OrderIssuesContainer>
      <HeaderContainer>
        <OrderIssuesHeading>{t('needHelp')}</OrderIssuesHeading>
      </HeaderContainer>
      <OrderIssuesDetails>
        <OrderIssuesText>{t('visitSupportForHelpWithYourOrder')}</OrderIssuesText>
        <Box>
          <StyledButton to={routes.support}>{t('visitSupport')}</StyledButton>
        </Box>
      </OrderIssuesDetails>

      {children}
    </OrderIssuesContainer>
  );
};
